export const getCarouselArrowSx = (theme) => ({
  width: 34,
  height: 34,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
});

export const getCarouselDotSx = (theme, { active }) => ({
  width: 10,
  height: 10,
  borderRadius: 9999,
  border: 0,
  padding: 0,
  backgroundColor: active
    ? theme.palette.text.primary
    : theme.palette.action.disabled,
  transition: "transform 160ms ease, opacity 160ms ease",
  opacity: active ? 0.85 : 0.5,
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-1px)",
    opacity: active ? 0.9 : 0.7,
  },
  "&:focus-visible": {
    outline: "3px solid rgba(25,118,210,0.35)",
    outlineOffset: 3,
  },
});

// Theme matching constraints apply ONLY to this bottom pill button.
export const getPillButtonSx = (theme) => ({
  border: 0,
  borderRadius: 9999,
  padding: "10px 16px",
  backgroundImage: `linear-gradient(135deg, ${theme.palette.primary[600]} 0%, ${theme.palette.primary[700]} 100%)`,
  border: `2px solid ${theme.palette.primary[800]}`,
  color: "white",
  fontWeight: 600,
  fontSize: 14,
  cursor: "pointer",
  transition: "transform 160ms ease, box-shadow 160ms ease",
  boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
  "&:hover": {
    transform: "translateY(-1px)",
    backgroundImage: `linear-gradient(135deg, ${theme.palette.primary[700]} 0%, ${theme.palette.primary[800]} 100%)`,
    border: `2px solid ${theme.palette.primary[900]}`,
    boxShadow: "0 10px 20px rgba(0,0,0,0.18)",
  },
  "&:active": {
    transform: "translateY(0px)",
    boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
  },
  "&:focus-visible": {
    outline: "3px solid rgba(25,118,210,0.35)",
    outlineOffset: 3,
  },
});
